<template>
  <div>
    <div class="services style-2 home s-2 bottom-3">
      <div class="container clearfix">
        <div class="one-third column">
          <div class="item bottom-4">
            <div class="circle float-left">
              <a><i class="icon-smile"></i></a>
            </div>
            <div class="data float-right">
              <p>
                {{ $t('method_intro_1') }}
              </p>
            </div>
          </div>
        </div>

        <div class="one-third column">
          <div class="item bottom-4">
            <div class="circle float-left">
              <a><i class="icon-play-sign"></i></a>
            </div>
            <div class="data float-right">
              <p>
                {{ $t('method_intro_2') }}
              </p>
            </div>
          </div>
        </div>

        <div class="one-third column">
          <div class="item bottom-4">
            <div class="circle float-left">
              <a><i class="icon-bullseye"></i></a>
            </div>
            <div class="data float-right">
              <p>
                {{ $t('method_intro_3') }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container main-content clearfix">

        <div class="two-thirds column bottom-3">

          <h3 class="title bottom-2">
            {{ $t('method_title_1') }}
          </h3>

          <div id="accordion" class="accordion style2 ui-accordion ui-widget ui-helper-reset" role="tablist">
            <div v-for="(methodItem,index) in methodList" :key="index">
              <h4 class="ui-accordion-header ui-helper-reset ui-accordion-icons ui-corner-all"
                  :class="[methodItem.open ? 'ui-state-active' : 'ui-state-default']"
                  v-on:click="toggleOpen(index)">

                <i class="ui-accordion-header-icon ui-icon"
                   :class="[methodItem.open ? 'icon-minus' : 'icon-plus']"></i>
                <a>{{ $t(methodItem.title) }}</a>
              </h4>
              <transition name="accordion"
                          v-on:before-enter="beforeEnter" v-on:enter="enter"
                          v-on:before-leave="beforeLeave" v-on:leave="leave">

                <div class="ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom"
                     v-show="methodItem.open">
                  <p>
                    {{ $t(methodItem.text) }}
                  </p>
                </div>
              </transition>
            </div>
          </div>

        </div>

        <div class="one-third column bottom-3">
          <h3 class="title bottom-2">{{ $t('method_title_2') }}</h3>

          <ul class="check-list why">
            <li v-for="(guarantee, idx) in guarantees" :key="idx">
              <a>{{ $t(guarantee) }}</a>
            </li>
          </ul>

          <img src="../../assets/images/Narabi_EU_Map_960x480.png" class="mapimg"/>

        </div>

      </div>

      <div class="container clearfix">
        <div class="sixteen columns clearfix">
          <hr class="line bottom-4">
        </div>
      </div>

      <contact-banner></contact-banner>

    </div>
  </div>
</template>

<script>
import ContactBanner from '../utilities/ContactBanner'

export default {
  name: 'NarabiMethod',
  components: { ContactBanner },
  methods: {
    toggleOpen (item) {
      // dont change key == item to strict comparison
      // console.log('item:', typeof item)
      for (let key in this.methodList) {
        // console.log('key:', typeof key)
        if (key == item) {
          this.methodList[key].open = !this.methodList[key].open
        } else {
          this.methodList[key].open = false
        }
      }
    },
    beforeEnter: function (el) {
      el.style.height = '0'
    },
    enter: function (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave: function (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave: function (el) {
      el.style.height = '0'
    }
  },
  data () {
    return {
      methodList: [
        {
          open: true,
          title: 'method_details_1',
          text: 'method_details_text_1'
        },
        {
          open: false,
          title: 'method_details_2',
          text: 'method_details_text_2'
        },
        {
          open: false,
          title: 'method_details_3',
          text: 'method_details_text_3'
        },
        {
          open: false,
          title: 'method_details_4',
          text: 'method_details_text_4'
        },
        {
          open: false,
          title: 'method_details_5',
          text: 'method_details_text_5'
        },
        {
          open: false,
          title: 'method_details_6',
          text: 'method_details_text_6'
        },
        {
          open: false,
          title: 'method_details_7',
          text: 'method_details_text_7'
        },
        {
          open: false,
          title: 'method_details_8',
          text: 'method_details_text_8'
        },
        {
          open: false,
          title: 'method_details_9',
          text: 'method_details_text_9'
        },
        {
          open: false,
          title: 'method_details_10',
          text: 'method_details_text_10'
        }
      ],
      guarantees: [
        'method_guarantees_1',
        'method_guarantees_2',
        'method_guarantees_3',
        'method_guarantees_4',
        'method_guarantees_5',
        'method_guarantees_6',
        'method_guarantees_7',
        'method_guarantees_8'
      ]
    }
  }
}
</script>

<style>

</style>
